import React from 'react';
import styled from 'styled-components';
import { grid, colors, sizes } from 'styles/theme';
import { media } from 'styles';

interface Props {
  children: React.ReactNode;
}

const Wrapper = styled.div`
  position: fixed;
  top: ${sizes.GlobalNavBar.height.default};
  left: ${sizes.InnerSidebar.width};
  z-index: 100;
  background: ${colors.white};
  padding: ${grid(2.5)};
  padding-bottom: 0;
  width: calc(100% - ${sizes.InnerSidebar.width});

  ${media.tablet`
    top: ${sizes.GlobalNavBar.height.tablet};
  `};
`;

const Spacer = styled.div`
  margin-bottom: -${grid(3)};
  padding: 0;
`;

export default class FixedListHeader extends React.Component<Props> {
  private wrapperRef: React.RefObject<HTMLDivElement> = React.createRef();
  private spacerRef: React.RefObject<HTMLDivElement> = React.createRef();

  componentDidMount() {
    this.setSpacerHeight();
  }

  componentDidUpdate() {
    this.setSpacerHeight();
  }

  setSpacerHeight() {
    if (!this.wrapperRef.current || !this.spacerRef.current) return;

    const wrapperHeight = this.wrapperRef.current.offsetHeight;
    this.spacerRef.current.style.height = `${wrapperHeight}px`;
  }

  render() {
    return (
      <>
        <Wrapper ref={this.wrapperRef}>{this.props.children}</Wrapper>
        <Spacer ref={this.spacerRef} />
      </>
    );
  }
}
